<template>
  <toggle-token-group
    ref="toggleTokenGroup"
    v-model="qualifications"
    :max-columns="2"
    :tokens="tokens"
    legend="Do you have any training or certifications?"
    @update:model-value="updateTokenState"
  />
</template>

<script lang="ts">
import ToggleTokenGroup from '@/components/toggle_token/ToggleTokenGroup.vue';
import { personCareQualificationsToggleTokenOptions } from './__types__/QualificationsTypes';
import focusOnElement, { FocusOnElementOptions } from '@/helpers/focusHelper';

export default {
  name: 'QualificationsStep',
  components: {
    ToggleTokenGroup,
  },
  computed: {
    qualifications: {
      get() {
        return this.$store.getters.getFormField('qualifications');
      },
      set(newValue) {
        return this.$store.dispatch('updateForm', { key: 'qualifications', value: newValue });
      },
    },
    tokens(): Object[] {
      return personCareQualificationsToggleTokenOptions.map((option) => ({
        ...option,
        value: this.qualifications.includes(option.type),
      }));
    },
  },
  methods: {
    focusElement(options: FocusOnElementOptions = {}) {
      focusOnElement(document.querySelector('.toggle-token-group') as HTMLElement, options);
    },
    updateTokenState(newTokens) {
      this.qualifications = newTokens.filter((option) => option.value).map((option) => option.type);
    },
  },
};
</script>
